
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skype",
      function () {
        return require("private-next-pages/skype/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skype"])
      });
    }
  